// extracted by mini-css-extract-plugin
export default {"skillWidget":"SkillWidget_skillWidget__nES0e","popIn":"SkillWidget_popIn__YFPjY"};